<template>
  <ContentDisplay
    class="operation-details__content"
    :footer-label="footerLabel"
    :footer-type="footerType"
    :footer-disabled="buttonLabel && buttonDisabled"
    :blocks-length="1"
    @click="emitOnButtonClick"
  >
    <template #content-block-1>
      <OrderDetailsField
        v-for="(field, index) in content.fields"
        :key="index"
        class="operation-details__field"
        :field="field"
        @on-field-click="emitOnFieldClick"
      />
    </template>
  </ContentDisplay>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { ContentDisplay } from '@warrenbrasil/nebraska-web';
import { OrderDetailsField } from '../OrderDetailsField';

import { OrderContent } from '@/modules/trade/services/orders';
import { FieldDetails } from '@/modules/trade/components/OrderModal/types';

@Component({
  components: {
    ContentDisplay,
    OrderDetailsField
  }
})
export default class OrderDetailsContent extends Vue {
  @Prop({ type: Object, required: true })
  readonly content!: OrderContent;

  @Prop({ type: String, required: false })
  readonly buttonLabel?: string;

  @Prop({ type: Boolean, default: false })
  readonly buttonDisabled!: boolean;

  @Emit('on-button-click')
  emitOnButtonClick() {}

  @Emit('on-field-click')
  emitOnFieldClick(fieldData: FieldDetails) {
    return fieldData;
  }

  get footerType() {
    return this.buttonLabel ? 'button' : 'caption';
  }

  get footerLabel() {
    return this.buttonLabel || this.content.caption;
  }
}
</script>

<style lang="less" scoped>
.operation-details {
  &__field {
    margin-bottom: @size-spacing-x300;
  }
}
</style>
